<div 
  class="field-error" 
  *ngIf="control.errors && control.touched">

  <div *ngIf="control.errors.required">
    {{ fieldName || 'This field' }} is required.
  </div>

  <div *ngIf="control.errors.maxlength">
    {{ fieldName || 'This field' }} should have maximum of {{ control.errors.maxlength.requiredLength }} characters.
  </div>
</div>
